"use client";

import { useId } from "react";
import { usePortalTranslations } from "../i18n/client";
import type { PortalPass } from "../lib/portalPasses";
import styles from "./PortalPassBookingSelect.module.css";

export function PortalPassBookingSelect({ passes, value, onChange, disabled = false }: { passes: PortalPass[]; value: string; onChange: (uuid: string) => void; disabled?: boolean }) {
  const t = usePortalTranslations();
  const id = useId();
  if (!passes.length) return null;
  return <div className={styles.field}>
    <label htmlFor={id}>{t("passes.booking.use")}</label>
    <select id={id} value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled} aria-describedby={`${id}-hint`}>
      <option value="">{t("passes.booking.noPass")}</option>
      {passes.map((pass) => <option value={pass.uuid} key={pass.uuid}>{pass.offerName} · {pass.availableQuantity === null ? t("passes.unlimited") : t(pass.kind === "minutes" ? "passes.minutes" : "passes.visits", { count: pass.availableQuantity })}</option>)}
    </select>
    <small id={`${id}-hint`}>{t("passes.booking.hint")}</small>
  </div>;
}
